import Scroller from 'vux/src/components/scroller/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'


const pulldownDefaultConfig = {
content: '下拉刷新',
height: 40,
autoRefresh: false,
downContent: '下拉刷新',
upContent: '释放后刷新',
loadingContent: '正在刷新...',
clsPrefix: 'xs-plugin-pulldown-'
}

const pullupDefaultConfig = {
content: '上拉加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '释放后加载',
upContent: '上拉加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
}

export default {
name: 'productList',
directives: {
TransferDom
},
components: {
Scroller,
Confirm,
XDialog,
},
data () {
return {
list: [],
page: 1,
postStatus: '所有状态',
pulldownDefaultConfig: pulldownDefaultConfig,
pullupDefaultConfig: pullupDefaultConfig,
noData: false,
searchText: '',
showConfirm: false,
confirmContent: '',
confirmEvent: '',
activeItem: '',
activeIndex: '',
activeItemOnceProduct: '',
activeIndexOnceProduct: '',
showReason: false,
failureReason: '',
}
},
methods: {
fetchData(cb) {
this.$request.post('/product/listProductByDesign',{
page: this.page,
rows: 10,
startTime: '',
endTime: '',
minPrice: '',
maxPrice: '',
searchContent: this.searchText,
searchStatus: this.postStatus
},).then(data => {
if(data.code == 0){
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
data.obj.rows.forEach((item, index) => {
let arr = []
let obj = {}
obj.materialName = item.materialName
obj.colorName = item.colorName
obj.salePrice = item.salePrice
obj.saleQtyTotal = item.saleQtyTotal
obj.status = item.skuPublishStatus
obj.statusName = item.skuSoldStatus
obj.id = item.skuId
obj.spuId = item.spuId
arr.push(obj)
item.materialList = [...arr]
item.materialList2 = [...arr]
item.isMore = true
})
cb(data.obj.rows)
console.log(data)
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
refresh() {
this.page = 1
this.fetchData(data => {
this.list = data
this.$refs.scrollerBottom.enablePullup()   
this.$refs.scrollerBottom.donePulldown()   
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
this.$vux.toast.show({
type: 'success',
text: '刷新成功'
})
console.log('下拉刷新成功')
})
this.page += 1
},
loadMore() {
this.fetchData(data => {
setTimeout(() => {
this.$vux.loading.hide()
}, 100);
this.$refs.scrollerBottom.enablePullup()
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
if(this.page == 1 && data.length == 0){
this.noData = true
this.$refs.scrollerBottom.disablePullup()
}else{
this.noData = false
}
this.list = this.list.concat(data)
console.log(this.list)
this.$refs.scrollerBottom.donePullup()
this.page += 1
})
},
changeStatus () {
this.postStatus = this.$refs.status.value
this.$vux.loading.show({
text: ''
})
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.list = []
this.page = 1
this.loadMore()
console.log(this.$refs.status.value)
},
search () {
this.$vux.loading.show({
text: ''
})
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.list = []
this.page = 1
this.loadMore()
console.log(this.searchText)
},
moreMaterialName (item2, index2) {
console.log(item2.skuId)
console.log(item2.spuId)
this.$request.post('/product/listSkuBySpuid',{
id: item2.skuId,
spuId: item2.spuId
},).then(data => {
if(data.code == 0){
data.obj.forEach((item, index) => {
let obj = {}
obj.materialName = item.materialName
obj.colorName = item.colorName
obj.salePrice = item.salePrice
obj.saleQtyTotal = item.saleQtyTotal
obj.status = item.publishStatus
obj.statusName = item.soldStatus
obj.id = item.id
obj.spuId = item.spuId
item2.materialList.push(obj)
})



console.log(JSON.parse(JSON.stringify(item2.materialList)))
item2.isMore = false
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
packUp (item2, index) {
item2.materialList = [...item2.materialList2]
item2.isMore = true
},
soldOut (item, index) {   //下架单个
this.confirmEvent = 'soldOut'
this.activeItem = item
this.activeIndex = index
this.showConfirm = true
this.confirmContent = '确定下架此商品吗？'
},
putaway (item, index) {   //上架单个
this.confirmEvent = 'putaway'
this.activeItem = item
this.activeIndex = index
this.confirmContent = '确定上架此商品吗？'
this.showConfirm = true
},
soldOutOnceProduct (item, index) {  //下架整条
this.confirmEvent = 'soldOutOnceProduct'
this.activeItemOnceProduct = item
this.activeIndexOnceProduct = index
this.showConfirm = true
this.confirmContent = '确定下架此商品吗？'
},
putawayOnceProduct (item, index) {  //上架整条
this.confirmEvent = 'putawayOnceProduct'
this.activeItemOnceProduct = item
this.activeIndexOnceProduct = index
this.showConfirm = true
this.confirmContent = '确定上架此商品吗？'
},
reason (item, index) {  //原因
this.failureReason = item.failureReason
this.showReason = true
},
onConfirm () {    //确定
if(this.confirmEvent == 'soldOut'){ //确定下架单个
this.$request.post('/product/updateStatusBySku',{
skuId: this.activeItem.id,
skuPublishStatus: 0,
}).then(data => {
if(data.code == 0){
this.activeItem.status = 0
this.activeItem.statusName = '上架'
this.$vux.toast.show({
type: 'success',
text: '下架申请提交成功'
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}else if(this.confirmEvent == 'putaway'){ //确定上架单个
this.$request.post('/product/skushelf',{
spuId: this.activeItem.spuId,
optype: 'SKU上架',
listSkus: [{skuId: this.activeItem.id, optype: '上架'}]
}).then(data => {
if(data.code == 0){
this.activeItem.status = 0
this.activeItem.statusName = '上架待审核'
this.$vux.toast.show({
type: 'success',
text: '上架申请提交成功'
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}else if(this.confirmEvent == 'soldOutOnceProduct'){ //确定下架整条
this.$request.post('/product/updateStatusBySpu',{
spuId: this.activeItemOnceProduct.spuId,
spuPublishStatus: 0,
}).then(data => {
if(data.code == 0){
this.list[this.activeIndexOnceProduct].spuPublishStatus = 0
this.list[this.activeIndexOnceProduct].spuSoldStatus = '上架'
this.$vux.toast.show({
type: 'success',
text: '下架申请提交成功'
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}else if(this.confirmEvent == 'putawayOnceProduct'){ //确定上架整条
this.$request.post('/product/spushelf',{
spuId: this.activeItemOnceProduct.spuId,
optype: 'SPU上架',
}).then(data => {
if(data.code == 0){
this.list[this.activeIndexOnceProduct].spuPublishStatus = 0
this.list[this.activeIndexOnceProduct].spuSoldStatus = 'SPU上架待审核'
this.$vux.toast.show({
type: 'success',
text: '上架申请提交成功'
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}
},
},
computed: {

},
created () {

},
mounted() {
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.loadMore()
},
}



// WEBPACK FOOTER //
// ./src/views/myStore/productList/script.js